import React, { useState } from "react";
import axios from "axios";
import { decryptToken } from "../utils/getToken";
import { Pen, Trash } from "lucide-react";

const QuestionRow = ({ q, refresh }) => {
  const [edit, setEdit] = useState(false);
  const [ques, setQues] = useState(q.ques);
  const [ans, setAns] = useState(q.ans);

  const token = decryptToken("accessToken") || "";
  const API = process.env.REACT_APP_LINK;

  const update = async () => {
    await axios.put(`${API}/faqques/${q.id}`, { ques, ans }, {
      headers: { Authorization: `Bearer ${token}` }
    });
    setEdit(false);
    refresh();
  };

  const remove = async () => {
    if (!window.confirm("Delete question?")) return;
    await axios.delete(`${API}/faqques/${q.id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    refresh();
  };

  return (
    <div className="faq-admin-question">
      {edit ? (
        <>
          <input value={ques} onChange={(e) => setQues(e.target.value)} />
          <textarea value={ans} onChange={(e) => setAns(e.target.value)} />
          <button className="savenow-faqnew" onClick={update}>Save</button>
          <button className="delete-quesfaq danger" onClick={() => setEdit(false)}>Cancel</button>
        </>
      ) : (
        <>
          <div>
            <strong>Q:</strong> {q.ques}
            <p><strong>A:</strong> {q.ans}</p>
          </div>
          <div className="actions">
            <button className="icon-btn" onClick={() => setEdit(true)}><Pen size={18}/></button>
            <button className="icon-btn danger" onClick={remove}><Trash size={18}/> </button>
          </div>
        </>
      )}
    </div>
  );
};

export default QuestionRow;
